<form *ngIf="parentForm" [formGroup]="parentForm" class="mt-2">
  <div *ngIf="product" [formGroupName]="productKey" style="padding:1px">
    <div class="d-flex align-items-center">
      <input
        type="checkbox"
        class="check-box-btn mr-2"
        [ngClass]="checkBoxColor"
        (click)="onToggleAccept()"
        [disabled]="disabled"
        [checked]="this.parentForm.get(this.productKey).get('accept').value"/>
      <span class="color-grey-4" [ngClass]="{ 'app-text-danger': !disabled && unverified }">{{ product.name }}</span>
    </div>
    <div class="app-inline-form-layout">
      <!-- product select -->
      <select
        class="border border-primary mr-1" style="min-width: 0"
        formControlName="selectedTerm"
        [attr.disabled]="this.parentForm.get(this.productKey).get('accept').value ? null : 'disabled'"
        (change)="submitParentForm()">
        <ng-container *ngIf="productKey === 'VSC' && hasProductNames()">
          <optgroup *ngFor="let group of getGroupedTermCosts()" [label]="group.productName">
            <option *ngFor="let item of group.termCosts" [ngValue]="item.index">
              {{ item.termCost.term }} Months / {{ isUnlimitedMiles(item.termCost.miles) ? "Unlimited" : (item.termCost.miles | number) + " Miles" }} - {{ item.termCost.price | currency }}
            </option>
          </optgroup>
        </ng-container>
        <ng-container *ngIf="productKey !== 'VSC' || !hasProductNames()">
          <option *ngFor="let termCost of product.termCosts | orderBy: 'term';let i = index" [ngValue]="i">
            {{ termCost.term }} Months
            / {{ isUnlimitedMiles(termCost.miles) ? "Unlimited" : (termCost.miles | number) + " Miles" }}
          </option>
        </ng-container>
      </select>
      <ng-container *ngIf="this.parentForm.get(this.productKey).get('accept').value">
        <a class="btn app-text-blue tight-padding hover-link-dotted"
           (click)="editValue()">{{ productPrice | currency }}</a>
      </ng-container>
      <ng-container *ngIf="!this.parentForm.get(this.productKey).get('accept').value">
        <div class="btn tight-padding" style="color:#999;cursor:default">{{ productPrice | currency }}</div>
      </ng-container>

    </div>
    <div *ngIf="productKey === 'VSC' && getSelectedProductName() && this.parentForm.get(this.productKey).get('accept').value"
         class="text-muted small mt-1">
      {{ getSelectedProductName() }}
    </div>
  </div>
  <div *ngIf="product.isFallbackTermCosts" style="color: #f66;font-weight:bold;font-size:11px;padding: 0 3px">Fallback
    term costs
  </div>
  <hr style="margin:5px 0 0 0">
</form>
